import React from 'react'
import { useActions } from 'src/hooks'
import { EditCampaignCardRoute } from '../../routes/EditCampaignCardRoute'
import { CampaignRoute } from 'src/campaigns/routes/CampaignRoute'
import Editor from 'src/editor/containers/Editor/Editor'
import { CardActionsProps } from '../AddCampaignCard/AddCampaignCard'
import { Text } from '@sendoutcards/quantum-design-ui'

const EditCampaignCard: React.FC<CardActionsProps> = props => {
  const { editableCampaign, campaignRoute, resetRoute } = props
  const { route } = props as { route: EditCampaignCardRoute }
  const actions = useActions()

  const handleCardUpdated = async () => {
    actions.openCampaigns(CampaignRoute(campaignRoute.campaignId))
  }

  return (
    <Editor
      cardId={route.cardId}
      onAfterSave={handleCardUpdated}
      onClose={resetRoute}
      context={{
        headerText: `Campaign: ${editableCampaign.name}`,
        footerLabel: () => (
          <Text type="caption" color="primaryHeading" weight="bold">
            {editableCampaign.lines.length} card
            {editableCampaign.lines.length > 1 && 's'}
          </Text>
        ),
        lines: editableCampaign.lines,
      }}
      saveButtonLabel="Update"
    />
  )
}

export default EditCampaignCard
